export default __webpack_public_path__ + "static/media/atle.426c863f.jpg";